import styled from "styled-components";

export const LinkedBankTournamentsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 32px;
`;